import Vue from 'vue';
import './plugins/bootstrap-vue';
import fontawesome from '@fortawesome/fontawesome-free/js/all';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  fontawesome,
  render: (h) => h(App),
}).$mount('#app');
